/** Cosmetic device condition — keep in sync with backend `ConditionRating`. */

export const CONDITION_RATINGS = [
  'new_sealed',
  'unused',
  'excellent',
  'good',
  'fair',
  'damaged',
] as const

export type ConditionRating = (typeof CONDITION_RATINGS)[number]

/** Desktop sell builder Būklė step — four summary tiers (matches product mockup). */
export const DESKTOP_BUILDER_CONDITION_RATINGS = [
  'excellent',
  'good',
  'fair',
  'damaged',
] as const satisfies readonly ConditionRating[]

export const CONDITION_COLORS: Record<ConditionRating, string> = {
  new_sealed: '#0f766e',
  unused: '#78d0d0',
  excellent: '#48a0b8',
  good: '#3a96a8',
  fair: '#b45309',
  damaged: '#b91c1c',
}

export function conditionColor(condition: string): string {
  return CONDITION_COLORS[condition as ConditionRating] ?? '#6b7280'
}

/** When seller skips condition, price guidance uses a conservative tier. */
export const LISTING_CONDITION_PRICING_FALLBACK: ConditionRating = 'fair'

export function isConditionRating(value: string | undefined | null): value is ConditionRating {
  return Boolean(value && (CONDITION_RATINGS as readonly string[]).includes(value))
}

export function conditionForPricing(selected: string | undefined | null): ConditionRating {
  return isConditionRating(selected) ? selected : LISTING_CONDITION_PRICING_FALLBACK
}

/** Stored on listing when seller did not pick condition (conservative for buyers). */
export function conditionForListingSubmit(
  selected: string | undefined | null,
  opts?: { superFastDefault?: ConditionRating },
): ConditionRating {
  if (isConditionRating(selected)) return selected
  return opts?.superFastDefault ?? LISTING_CONDITION_PRICING_FALLBACK
}
